/* CACHE — scroll reveals + count-up. Pure transform/opacity. Reduced-motion safe. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Staged hero entrance: set per-element delays, then flip .is-ready */
  document.querySelectorAll('.hero').forEach(function (hero) {
    var items = hero.querySelectorAll('[data-hero]');
    items.forEach(function (el, i) {
      el.style.setProperty('--hero-delay', (i * 160) + 'ms');
    });
    requestAnimationFrame(function () { hero.classList.add('is-ready'); });
  });

  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
    document.querySelectorAll('[data-countup]').forEach(function (el) { el.textContent = el.getAttribute('data-countup'); });
    return;
  }

  /* Generic reveal, honoring staggered delay from data-reveal-index */
  var revealIO = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var idx = parseInt(el.getAttribute('data-reveal-index') || '0', 10);
      el.style.setProperty('--reveal-delay', (idx * 90) + 'ms');
      el.classList.add('is-visible');
      obs.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-animate]').forEach(function (el) { revealIO.observe(el); });

  /* Count-up for macro stats */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-countup'));
    if (isNaN(target)) { el.textContent = el.getAttribute('data-countup'); return; }
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var start = performance.now(), dur = 1100;
    function tick(now) {
      var t = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = prefix + Math.round(target * eased) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var countIO = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      countUp(entry.target);
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-countup]').forEach(function (el) { countIO.observe(el); });
})();
